import axios from "layouts/authentication/api/axios";

export const loadJson = async (jsonURL) => {
    try {
        const res = await axios().get(jsonURL)
        return JSON.parse(res.data)
    } catch (e) {}

    return null
}